import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as Sentry from '@sentry/vue';

//import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import 'vuetify/dist/vuetify.css';
import 'intro.js/introjs.css';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import Vue from 'vue';
// @ts-ignore
import VueNumerals from 'vue-numerals';

import router from './routes/index';
import store from './store';
import Vuetify from 'vuetify';
import '@/components/extensions.js';
// @ts-ignore
import enumerator from '@/components/enumerator.js';
import Toasted from 'vue-toasted';
import TablePreloader from '@/components/datatable/table-preloader';

import UIService from '@/components/ui/ui-service';

// @ts-ignore
import App from './App.vue';

//@ts-ignore
import HighchartsVue from 'highcharts-vue';
//@ts-ignore
import VueIntercom from 'vue-intercom';

//@ts-ignore
import introJs from 'intro.js';
//@ts-ignore
window.introJs = introJs;

// @ts-ignore
import VueIntro from 'vue-introjs';

//@ts-ignore
import VueVirtualScroller from 'vue-virtual-scroller';

import i18n from '@/i18n/index';
import Bus from './services/evbus';
import FilterService from './services/filter';
import ColumnsService from './services/columns';
import ColorsService from '@/services/colors'
import HelpersService from '@/services/helpers';
import GlobalUtils from '@/services/globalUtils';
import ru from 'vuetify/src/locale/ru'
import es from 'vuetify/src/locale/es'
import zhHans from 'vuetify/src/locale/zh-Hans'

import errors_handler from './services/errors';

import config from './config';

import { Component } from 'vue-property-decorator';

//@ts-ignore
import Modal from '@/components/ui/ui-modal/modal/modal';

import VueCookies from 'vue-cookies-ts';

//WARNING: do not move this styles up! order is important
import '@/styles/_index.scss';

// Register the router hooks with their names
Component.registerHooks([
  'activated',
]);

//@ts-ignore
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import FF from '@/services/ff';
import PL from '@/services/planLimits';
import Mixpanel from '@/services/mixpanel';

Sentry.init({
  Vue,
  dsn: 'https://f5784c85c2d8f06fae1f2ca1921d9450@o4509434140426240.ingest.us.sentry.io/4509434144030720',
  sendDefaultPii: true,
  environment:process.env.VUE_APP_CONFIG_NAME
});

Vue.component('vc-date-picker', DatePicker)
Vue.component('modal', Modal)


Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.prototype.bus = Bus;

Vue.use(FilterService);
Vue.use(ColumnsService);
Vue.use(ColorsService);
Vue.use(UIService);
Vue.use(HelpersService);
Vue.use(GlobalUtils);
Vue.use(FF);
Vue.use(PL);

if(process.env.VUE_APP_MODE!=='cypress') {
  Vue.use(VueIntercom, { appId: 'shef0m4i' });
  Vue.use(Mixpanel);
}
Vue.use(VueNumerals, { locale: 'en' });

Vue.use(VueIntro);


Vue.use(HighchartsVue);

Vue.use(TablePreloader);
Vue.use(enumerator);
Vue.use(require('vue-moment'));

Vue.use(Toasted);

Vue.prototype.$config = config;

// Vue.prototype.$toasted.show = debounce(Vue.prototype.$toasted.show, 500);

Vue.use(Vuetify, {
  iconfont: 'fa',
  icons: {},
  ripple: false,
  lang: {
    locales: { ru, zhHans, es },
    current: 'en',
  },
});

Vue.use(VueCookies);

Vue.use(VueVirtualScroller);

// // @ts-ignore
// import UiMenu from '@/components/ui/ui-menu.vue';

// Vue.component('ui-menu', UiMenu);
if (process.env.VUE_APP_CONFIG_NAME !== 'production') {
  Vue.config.errorHandler = function(err, vm, info) {
    console.error(err, vm, info);
  }
}

const app = new Vue({
  //@ts-ignore
  i18n,
  router,
  store,
  //@ts-ignore
  render: h => h(App)
}).$mount('#application');

(window as any).$app = app;

if(process.env.VUE_APP_MODE!=='cypress'){
  app.$mixpanel.init(config.mixpanel, {
    'track_pageview':false,
  },null);

  if(store.state.impersonation.id){
    app.$mixpanel.disable();
  }
}

errors_handler(app);


// //OPTIMIATION: 'resize' directive loads cpu
// Vue.directive('resize', function (value: any) {});


Vue.directive('click-outside-bemob', {
  bind: function (el: any, binding: any, vnode: any) {
    el.clickOutsideEvent = function (event: any) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el: any) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

export default app;
